import { memo } from 'react';
import { Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import CustomSwitch from 'components/Forms/CustomSwitch';
import { SwitcherWrapper } from 'pages/TableOrdering/styles';
import useDeliveryAutoConfirm from 'pages/Providers/TableOrdering/hooks/useDeliveryAutoConfirm';
import { SETTINGS_TABLE_OPTIONS, useTableOrderingSettings } from 'pages/TableOrdering/hooks/useTableOrderingSettings';

const DeliveryAutoConfirm = ({ items, srv, isDisableAutoConfirm, handleOpenAutoConfirmModal, type }) => {
  const { t } = useTranslation();
  const { loadingSettings } = useSelector(({ tableOrdering }) => tableOrdering);
  const { settingsDelivery, handleDeliverySubmit, handleDeliveryChange, selectedOptions } = useTableOrderingSettings();
  const { autoConfirmDelivery, handleSubmit, handleConfirm, loading } = useDeliveryAutoConfirm(items, srv);

  return (
    <>
      <FormProvider {...settingsDelivery}>
        <form
          onSubmit={settingsDelivery.handleSubmit(handleDeliverySubmit)}
          style={{
            width: '100%',
            mt: 3,
          }}
        >
          {loadingSettings && selectedOptions === SETTINGS_TABLE_OPTIONS.DELIVERY && <Preloader overlay={true} />}
          <SwitcherWrapper
            sx={{ ml: 2, mt: 2 }}
          >
            <CustomSwitch
              onChange={handleDeliveryChange}
              name="isEnable"
              checked={settingsDelivery.getValues()?.isEnable}
              label={t('table_ordering.delivery_switcher')}
            />
          </SwitcherWrapper>
        </form>
      </FormProvider>
      <Divider />
      <FormProvider {...autoConfirmDelivery}>
        <form
          onSubmit={autoConfirmDelivery.handleSubmit(handleSubmit)}
          style={{
            width: '100%',
            mt: 3,
          }}
        >
          {loading && <Preloader overlay={true} />}
          <SwitcherWrapper
            sx={{ ml: 2, mt: 2 }}
            onClick={isDisableAutoConfirm ? handleOpenAutoConfirmModal : () => {}}
          >
            <CustomSwitch
              disabled={isDisableAutoConfirm || !settingsDelivery.getValues()?.isEnable}
              name="orderConfirm.delivery.autoConfirm"
              checked={autoConfirmDelivery.getValues()?.orderConfirm?.delivery?.autoConfirm}
              label={t(`Auto-confirm ${type} order`)}
              onChange={(event) => handleConfirm(event)}
            />
          </SwitcherWrapper>
        </form>
      </FormProvider>
    </>
  );
};

export default memo(DeliveryAutoConfirm);
